
<div class="modal-header bg-light">
  <h5 class="modal-title">Feriado - {{ fechaMostrar }}</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <textarea maxlength="255" class="form-control" [(ngModel)]="detail" placeholder="Detalle del feriado" id="textarea" style="height: 100px"></textarea>
  <small>{{detail.length}}/255 caracteres.</small>
  @if(!nuevoFeriado) {
    <div class="mt-1">
      <input type="checkbox" class="form-check-input" [(ngModel)]="activo" (click)="cambiarActivo()"> Activo
    </div>
    <div class="mt-1">
      <label>Responsable: {{this.responsable}}</label>
    </div>
  }
</div>
<div class="modal-footer">
  <button [disabled]="guardandoFeriado" type="button" class="btn btn-primary" (click)="onSave()">
      <span *ngIf="!guardandoFeriado">Guardar</span>
      <div *ngIf="guardandoFeriado" class="d-flex align-items-center">
          <div class="spinner-border text-light spinner-border-sm" role="status"></div>
          <span>Guardando...</span>
      </div>
  </button>
  <button [disabled]="guardandoFeriado" type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="activeModal.close([])">Cancelar</button>
</div>
